import React from 'react';
import styled from 'styled-components';
import { graphql } from '@apollo/client/react/hoc';
import { Input, Divider, Modal, Spin, Col, Row, Button, DatePicker, Switch, List, Tooltip } from 'antd';
import { compose } from '../../core';
import { getIntFromString, getOrgListFromTeam, getOrgListFromVer, OrganizationTransfer, removeDuplicate } from '../../look';
import { withEditSurvey } from './SurveyOperations';
import OrganizationTree from './OrganizationTree';
import { IMG } from '../../../config';
import {
  withOrganizationState,
  withAllOrganization,
  withOrganizationFilterUpdating
} from '../../organization/containers/OrganizationOperation';
import SelectFilterField from '../../look/components/SelectFilterField';

const SurveyAssign = props => {
  const {
    assign,
    setAssign,
    SurveyById,
    onFiltersRemove,
    editSurvey,
    allOrganization,
    onNameChange,
    onDescriptionChange,
    onEmailChange
  } = props;
  const [visible, setVisible] = React.useState(false);
  const [orgId, setOrgId] = React.useState(0);
  const [tree, setTree] = React.useState(false);
  const handleSubmit = async organizations => {
    try {
      await editSurvey({ id: getIntFromString(SurveyById.id), name: SurveyById.name, organizations });
    } catch (e) {
      throw new Error(e.message);
    }
  };
  const allVerticals =
    SurveyById && SurveyById.vertical && SurveyById.vertical.edges.map(({ node }) => getIntFromString(node.id));
  const allTeams = SurveyById && SurveyById.team && SurveyById.team.edges.map(({ node }) => getIntFromString(node.id));
  const allOrganizations =
    SurveyById && SurveyById.organization && SurveyById.organization.edges.map(({ node }) => getIntFromString(node.id));
  const renderOrgList = (org, header = false) => (
    <ListScroll
      header={header && <div align="center">Organizations</div>}
      // footer={<div>Footer</div>}
      bordered
      dataSource={(org && org?.edgeCount > 0 && org?.edges.map(({ node }) => node)) || []}
      renderItem={item => (
        <Selectable>
          {/* <OrganizationTree item={item} orgId={getIntFromString(item.id)} /> */}
          <List.Item>
            <Row justify="space-between">
              <Col
                type="default"
                ghost
                onClick={() => {
                  setOrgId(item.id);
                  setTree(true);
                }}
              >
                <img src={IMG} alt="" style={{ width: 40, borderRadius: 30, marginRight: 10 }} /> {`${item.name}`}
              </Col>
            </Row>
          </List.Item>
        </Selectable>
      )}
    />
  );

  const assignedOrg = removeDuplicate([
    ...((SurveyById?.organization && SurveyById?.organization?.edgeCount > 0 && SurveyById?.organization?.edges) || []),
    ...((SurveyById?.vertical && SurveyById.vertical?.edgeCount > 0 && getOrgListFromVer(SurveyById.vertical).edges) || []),
    ...((SurveyById?.team && SurveyById.team?.edgeCount > 0 && renderOrgList(getOrgListFromTeam(SurveyById.team)).edges) ||
      [])
  ]);

  return (
    <>
      <Button type="primary" ghost onClick={() => setAssign(true)}>
        Survey Assigned
      </Button>

      <Modal
        destroyOnClose
        visible={assign}
        onCancel={() => setAssign(false)}
        centered
        footer={null}
        title="Survey Assigned"
        width={'45%'}
        bodyStyle={{ padding: 16, minHeight: '80%' }}
      >
        {visible ? (
          <>
            <Row>
              <Button type="primary" onClick={() => setVisible(false)}>
                All Organizations
              </Button>
            </Row>
            <br />
            {SurveyById && renderOrgList(assignedOrg, true)}
          </>
        ) : (
          <>
            <Row justify="space-between">
              <Button type="primary" onClick={() => setVisible(true)}>
                Assigned
              </Button>

              <SelectFilterField
                placeholder="Search Organization by"
                onFiltersRemove={onFiltersRemove}
                options={[
                  {
                    label: 'Name',
                    type: 'text',
                    value: onNameChange
                  },
                  {
                    label: 'Description',
                    type: 'text',
                    value: onDescriptionChange
                  },
                  {
                    label: 'Email',
                    type: 'text',
                    value: onEmailChange
                  }
                ]}
              />
            </Row>
            <br />

            {allOrganization && allOrganization.edgeCount > 0 && (
              <ListScroll
                header={<div align="center">Organizations</div>}
                // footer={<div>Footer</div>}
                bordered
                dataSource={
                  allOrganization &&
                  allOrganization.edgeCount > 0 &&
                  allOrganization.edges
                    .filter(({ node }) => assignedOrg?.edges?.map(({ node }) => node.id).indexOf(node.id) === -1)
                    .map(({ node }) => node)
                }
                renderItem={item => (
                  <Selectable>
                    {/* <OrganizationTree item={item} orgId={getIntFromString(item.id)} /> */}
                    <List.Item>
                      <Row justify="space-between">
                        <Col
                          type="default"
                          ghost
                          onClick={() => {
                            setOrgId(item.id);
                            setTree(true);
                          }}
                        >
                          <img src={item.logo || IMG} alt="" style={{ width: 40, borderRadius: 40, marginRight: 10 }} />{' '}
                          {`${item.name}`}
                        </Col>
                      </Row>
                    </List.Item>
                  </Selectable>
                )}
              />
            )}
          </>
        )}
      </Modal>

      <Modal
        destroyOnClose
        centered
        visible={tree}
        onCancel={() => setTree(false)}
        footer={null}
        title="Survey Assigned"
        width={'80%'}
        bodyStyle={{ padding: 16, maxHeight: '80vh', overflowX: 'scroll' }}
      >
        {tree && (
          <OrganizationTree
            orgId={getIntFromString(orgId)}
            surveyId={SurveyById.id}
            surveyName={SurveyById.name}
            allVerticals={allVerticals}
            allTeams={allTeams}
            allOrganizations={allOrganizations}
            editSurvey={editSurvey}
          />
        )}
      </Modal>
    </>
  );
};

const Selectable = styled.div`
  &:hover {
    cursor: pointer;
    background-color: #fffff0;
  }
`;

const ListScroll = styled(List)`
  .ant-list-items {
    max-height: 60vh;
    overflow-y: scroll;
  }
`;
export default compose(
  withOrganizationState,
  withAllOrganization,
  withOrganizationFilterUpdating,
  withEditSurvey
)(SurveyAssign);
